<template>
  <div class="dropdown toolbtn flex-shrink-0 p-0" role="button" ref="btn">
    <div
      :class="{ show: open }"
      class="btn toolbtn btn-icon btn-active-light-primary"
      @click="toggle"
    >
      <svg
        focusable="false"
        class="chooser"
        style="height: 22px; margin-top: 19%; width: 24px"
      >
        <path
          fill="#a1a5b7"
          d="M6,8c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM12,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM6,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM6,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM12,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM16,6c0,1.1 0.9,2 2,2s2,-0.9 2,-2 -0.9,-2 -2,-2 -2,0.9 -2,2zM12,8c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,14c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2zM18,20c1.1,0 2,-0.9 2,-2s-0.9,-2 -2,-2 -2,0.9 -2,2 0.9,2 2,2z"
        ></path>
      </svg>
    </div>
    <ul class="dropdown-menu" :class="{ show: open }" style="min-width: 200px">
      <li v-for="(app, app_index) in apps" :key="app_index" class="my-1">
        <!-- purposefully hide paitent center for now -->
        <a
          class="dropdown-item"
          :href="!isActive(app) ? `http://${app.path}${domain}` : null"
          target="_new"
        >
          <span class="pt-2" style="position: absolute; float: left">
            <i
              v-show="isActive(app)"
              class="fa fa-period fa-2xl"
              style="color: limegreen"
            ></i>
          </span>
          <img :src="app.logo.default" class="ps-3 pt-1" style="height: 100%" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AppChooser',
  props: {
    env: {
      type: String,
      required: true,
    },
    currentApp: {
      type: String,
      required: true,
    },
  },
  async mounted() {
    this.apps = await this.getApps();
    window.addEventListener('click', e => {
      if (!this.$refs.btn?.contains(e.target)) {
        this.open = false;
        // Clicked outside the box
      }
    });
  },
  data() {
    return {
      open: false,
      apps: [],
    };
  },
  computed: {
    domain() {
      let domain = 'resonancehealth.org';
      switch (this.env) {
        case 'stage':
          domain = 'stage.resonancehealth.org';
          break;
        case 'production':
          domain = 'resonancehealth.org';
          break;
      }
      return domain;
    },
  },
  methods: {
    // async because we have to import the img files
    async getApps() {
      return [
        {
          name: 'patient-center',
          logo: await import(
            '../../assets/img/apps/patient-center-logo-light.png?url'
          ),
          path: 'patients.',
          id: 1,
        },
        {
          name: 'networks',
          logo: await import(
            '../../assets/img/apps/networks-logo-light.png?url'
          ),
          path: 'networks.',
          id: 2,
        },
        {
          name: 'home',
          logo: await import('../../assets/img/apps/home-logo-light.png?url'),
          path: '',
          id: 3,
        },
      ];
    },
    isActive(app) {
      return app.name == this.currentApp;
    },
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>

<style>
.menu.menu-sub.menu-sub-custom.menu-custom {
  width: 182px;
}
.menu-state-primary .menu-item .menu-link:hover {
  background-color: rgb(224, 226, 229);
}
.menu-state-primary .menu-item .menu-link.active {
  background-color: rgb(224, 226, 229);
}
.caret-current {
  color: #00c9a7;
  position: absolute;
  top: 23px;
}
.toolbtn a.dropdown-item {
  height: 50px;
  padding: 0.25rem 1rem !important;
}
</style>
